module.exports = __webpack_public_path__ + "img/elm-s.68e122b8.png";